import { useState } from 'react';
import type { UploadFile, UploadProps } from 'antd';
import { message } from 'antd';
import { RcFile } from 'antd/es/upload';

import { BulkSubscriptionEligibiltyResult } from '@app/domain-bundle-interfaces';
import { Auth } from '@app/web-components';

import { useUploadFile } from '../../data/upload';
import { useParseFile } from '../../data/utils/parse-file';

export const useFileUpload = (bundleId?: number, bundleAccessIds?: number[]) => {
  const [bulkUploadTableData, setBulkUploadTableData] = useState<BulkSubscriptionEligibiltyResult[]>([]);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [fileUploadError, setFileUploadError] = useState<string>('');
  const parseFile = useParseFile();
  const uploadFile = useUploadFile();
  const uploadProps: UploadProps = {
    disabled: !bundleAccessIds || bundleAccessIds?.length === 0,
    name: 'bulkSubscriptionfile',
    accept: 'text/plain',
    multiple: false,
    maxCount: 1,
    listType: 'picture',
    fileList: fileList,
    locale: { uploadError: fileUploadError },
    beforeUpload: (file, FileList) => {
      console.log('beforeUpload File List', FileList);
      const isValidFileType = file.type === 'text/plain';
      if (!isValidFileType) {
        message.error('Please upload a text file!');
        setFileList([]);
        return isValidFileType;
      }
      if (FileList.length > 1) {
        message.error('You can only upload one file at a time!');
        return false;
      }
    },
    //action: 'http://localhost:3333/api/upload/file',
    customRequest: async ({ file, onSuccess, onError, filename }) => {
      console.log('accessIds', bundleAccessIds);
      await parseFile(file as RcFile)
        .then((enterpriseIds) => {
          console.log('parsedEnterpriseIds', enterpriseIds);
          uploadFile({ enterpriseIds, bundleId: bundleId || 0, bundleAccessIds: bundleAccessIds || [] })
            .then((response) => {
              if (onSuccess) {
                console.log('response from file upload tsx', response);
                setBulkUploadTableData([...(response?.map((item: BulkSubscriptionEligibiltyResult) => item) ?? [])]);
                onSuccess({ file: file as RcFile, filename: filename, response: response });
              }
              //message.success(`${(file as RcFile).name} uploaded successfully`);
            })
            .catch((err) => {
              if (onError) {
                onError(new Error('Upload failed'));
              }
              console.log(err);
              setFileUploadError(err);
              return [];
            });
        })
        .catch((err) => {
          if (onError) {
            onError(new Error('Upload failed'));
          }
          console.error('Error parsing file', err);
          setFileUploadError(err);
          return [];
        });
    },
    headers: {
      Authorization: `Bearer ${Auth.useUserAuth().token}`,
    },

    onChange(info) {
      setFileList(
        info.fileList.map((file) => {
          if (info.file.status === 'error') {
            if (file.error) {
              file.error.message = fileUploadError;
            } else {
              file.error = { message: fileUploadError };
            }
          }
          return file;
        }),
      );
    },
    onRemove: () => {
      setBulkUploadTableData([]);
    },
  };

  return { uploadProps, bulkUploadTableData };
};
